export const EVENT_CLASSES = ['Bronze', 'Silver', 'Gold', 'Diamond', 'Platinum'];
export const EVENT_TYPES = ['None', 'Fishing', 'Farming', 'Collecting', 'ParadiseLegends', 'KeyEvent'];
export const DATA_COLLECTION_TYPES = ['Count', 'Max', 'Min', 'Sum'];
export const SUBMISSION_LIMIT_TYPES = ['Daily', 'Event'];
export const GAME_MODES = ['None', 'Timed', 'Endless'];
